import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared/shared.module';
import { ResetPasswordComponent } from './reset-password.component';

@NgModule({
	imports: [SharedModule],
	exports: [],
	declarations: [ResetPasswordComponent],
	providers: []
})
export class ResetPasswordModule {}
